import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    FormControlLabel,
    Checkbox,
    FormControl,
    InputLabel,
    Select,
    MenuItem
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IGroup } from '../../models/IEvent';

export interface IQuickEditRider {
    tagIdFriendly: string;
    name: string;
    trial: boolean;
    group: string;
}

interface IQuickEditDialogProps {
    open: boolean;
    rider: IQuickEditRider | null;
    groups: IGroup[];
    onSave: (tagIdFriendly: string, trial: boolean, group: string) => void;
    onCancel: () => void;
}

function QuickEditRiderDialog(props: IQuickEditDialogProps) {
    const { t } = useTranslation("common");
    const [trial, setTrial] = useState<boolean>(props.rider?.trial ?? false);
    const [group, setGroup] = useState<string>(props.rider?.group ?? '');

    useEffect(() => {
        if (props.rider) {
            setTrial(!props.rider.trial);
            setGroup(props.rider.group);
        }
    }, [props.rider]);

    const handleSave = () => {
        if (props.rider) {
            props.onSave(props.rider.tagIdFriendly, trial, group);
        }
    };

    return (
        <Dialog open={props.open} onClose={props.onCancel} aria-labelledby="quick-edit-dialog-title">
            <DialogTitle id="quick-edit-dialog-title">
                {t("rider.rider")}: {props.rider?.name}
            </DialogTitle>
            <DialogContent>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={trial}
                            onChange={(e) => setTrial(e.target.checked)}
                        />
                    }
                    label={t("rider.trial")}
                />
                <FormControl fullWidth variant="outlined" margin="dense">
                    <InputLabel id="quick-edit-group-label">{t("rider.group")}</InputLabel>
                    <Select
                        labelId="quick-edit-group-label"
                        label={t("rider.group")}
                        value={group}
                        onChange={(e) => setGroup(typeof e.target.value === 'string' ? e.target.value : '')}
                    >
                        {props.groups.map((g) => (
                            <MenuItem key={g.groupId} value={g.groupId}>{g.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSave} color="primary">
                    {t("commonActions.ok")}
                </Button>
                <Button onClick={props.onCancel} color="primary">
                    {t("commonActions.cancel")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default QuickEditRiderDialog;
